import React from 'react'

import './CssBaseline.scss'

export default function CssBaseline(props) {
	const { children } = props
	return <React.Fragment>{children}</React.Fragment>
}
